const translation = {
  daysInWeek: {
    Sun: 'Sol',
    Thu: 'Jue',
    Tue: 'Mar',
    Sat: 'Sáb',
    Mon: 'Mon',
    Fri: 'Viernes',
    Wed: 'Miércoles',
  },
  months: {
    August: 'Agosto',
    September: 'Septiembre',
    April: 'Abril',
    February: 'Febrero',
    January: 'Enero',
    November: 'Noviembre',
    October: 'octubre',
    May: 'Mayo',
    June: 'Junio',
    December: 'Diciembre',
    July: 'Julio',
    March: 'Marzo',
  },
  operation: {
    ok: 'De acuerdo',
    pickDate: 'Seleccionar fecha',
    cancel: 'Cancelar',
    now: 'Ahora',
  },
  title: {
    pickTime: 'Elegir hora',
  },
  defaultPlaceholder: 'Elige una hora...',
}

export default translation
